export const DEFAULT_SAME_DAY_CUT_OFF_TIME = [
  "12:00:00",
  "12:00:00",
  "12:00:00",
  "12:00:00",
  "12:00:00",
  "12:00:00",
  "12:00:00",
];
export const DEFAULT_EARLIEST_READY_TIME = [
  "09:00:00",
  "09:00:00",
  "09:00:00",
  "09:00:00",
  "09:00:00",
  "09:00:00",
  "09:00:00",
];
export const DEFAULT_LATEST_READTY_TIME = [
  "17:00:00",
  "17:00:00",
  "17:00:00",
  "17:00:00",
  "17:00:00",
  "17:00:00",
  "17:00:00",
];
export const DEFAULT_SATURN_AUTO = [true, true, true, true, true, true, true];

export const DEFAULT_MIN_DUTY_TIME = "01:00";
export const DEFAULT_AM_TIME_IN_DEPOT = "11:00";
export const DEFAULT_PM_TIME_IN_DEPOT = "11:00";
